const MEMBER_SIZE_BUCKETS = [
  { name: "Tiny", label: "<20 members", filterLabel: "<20" },
  { name: "Small", label: "20-100 members", filterLabel: "20 - 100" },
  { name: "Medium", label: "100-1,000 members", filterLabel: "100 - 1,000" },
  {
    name: "Large",
    label: "1,000-10,000 members",
    filterLabel: "1,000 - 10,000",
  },
  {
    name: "Huge",
    label: "10,000-100,000 members",
    filterLabel: "10,000 - 100,000",
  },
  {
    name: "Massive",
    label: "100,000-1M members",
    filterLabel: "100,000 - 1,000,000",
  },
  { name: "Gigantic", label: "1M+ members", filterLabel: "1,000,000+" },
]

const SIZES = [...MEMBER_SIZE_BUCKETS.map(bucket => bucket.name), "Unknown"]

function convertMembersToSize(count) {
  if (!count) {
    return "Unknown"
  } else if (count < 20) {
    return "Tiny"
  } else if (count < 100) {
    return "Small"
  } else if (count < 1000) {
    return "Medium"
  } else if (count < 10000) {
    return "Large"
  } else if (count < 100000) {
    return "Huge"
  } else if (count < 1000000) {
    return "Massive"
  }
  return "Gigantic"
}

function getMemberSizeLabel(name) {
  const bucket = MEMBER_SIZE_BUCKETS.find(item => item.name === name)
  return bucket ? bucket.label : name
}

function getMemberSizeFilterLabel(name) {
  const bucket = MEMBER_SIZE_BUCKETS.find(item => item.name === name)
  return bucket ? bucket.filterLabel : name
}

module.exports = {
  MEMBER_SIZE_BUCKETS,
  SIZES,
  convertMembersToSize,
  getMemberSizeLabel,
  getMemberSizeFilterLabel,
}
